import React, { lazy } from 'react';
import shortid from 'shortid';
import {
  Home,
  Package,
  Users,
  FileText,
  ShoppingCart,
  Archive,
  Truck,
  Database,
  PieChart,
  Clipboard,
  BarChart2,
  CheckCircle,
  Activity,
  Shield,
  Repeat,
  AlertOctagon,
  Settings,
  Clock,
} from 'react-feather';

export const privateConstant = [
  {
    id: shortid.generate(),
    name: 'Tổng quan',
    path: '/dashboard',
    accessName: 'dashboard',
    icon: <Home size={18} />,
    component: lazy(() => import('../../views/Dashboard')),
    exact: true,
  },
  {
    id: shortid.generate(),
    name: 'Sản phẩm',
    accessName: 'products',
    path: '/products',
    icon: <Package size={18} />,
    isSubMenu: true,
    child: [
      {
        id: shortid.generate(),
        name: 'Danh sách sản phẩm',
        path: '/products',
        icon: <Package size={18} />,
        component: lazy(() => import('../../views/Products')),
        exact: true,
      },
      {
        id: shortid.generate(),
        name: 'Hàng trong kho',
        path: '/stock-management/balances',
        icon: <Shield size={18} />,
        accessName: 'products',
        component: lazy(() => import('../../views/StockManagementBalances')),
        exact: true,
      },
    ],
  },
  {
    id: shortid.generate(),
    path: '/products/addnew/:projectId?',
    component: lazy(() => import('../../views/ProductDetail')),
    exact: true,
    hidden: true,
  },
  {
    id: shortid.generate(),
    path: '/products/:projectId/:productId/',
    component: lazy(() => import('../../views/ProductDetail')),
    exact: true,
    hidden: true,
  },
  {
    id: shortid.generate(),
    name: 'Khách hàng',
    path: '/customer',
    accessName: 'customers',
    icon: <Users size={18} />,
    child: [
      {
        id: shortid.generate(),
        path: '/customer',
        component: lazy(() => import('../../views/Customer')),
        exact: true,
      },
      {
        id: shortid.generate(),
        path: '/customer/addNew/:projectId',
        component: lazy(() => import('../../views/CustomerDetail')),
        exact: true,
      },
      {
        id: shortid.generate(),
        path: '/customer/:projectId/:id',
        component: lazy(() => import('../../views/CustomerDetail')),
        exact: true,
      },
    ],
  },
  {
    id: shortid.generate(),
    name: 'Đơn hàng',
    path: '/order',
    accessName: 'orders',
    icon: <FileText size={18} />,
    child: [
      {
        id: shortid.generate(),
        path: '/order',
        component: lazy(() => import('../../views/Order')),
        exact: true,
      },
      {
        id: shortid.generate(),
        path: '/order/addNew/:projectId',
        accessName: 'create_orders',
        component: lazy(() => import('../../views/OrderDetail')),
        exact: true,
      },
      {
        id: shortid.generate(),
        path: '/order/:projectId/:id',
        component: lazy(() => import('../../views/OrderDetail')),
        exact: true,
      },
    ],
  },
  {
    id: shortid.generate(),
    name: 'Đặt hàng',
    accessName: 'inventory_buy',
    path: '/inventoryBuy',
    icon: <ShoppingCart size={18} />,
    child: [
      {
        id: shortid.generate(),
        path: '/inventoryBuy',
        component: lazy(() => import('../../views/InventoryBuy')),
        exact: true,
      },
      {
        id: shortid.generate(),
        path: '/inventoryBuy/:projectId/:id',
        component: lazy(() => import('../../views/InventoryBuyDetail')),
        exact: true,
      },
    ],
  },
  {
    id: shortid.generate(),
    name: 'Kho vận',
    path: '/inventory',
    accessName: 'inventory',
    icon: <Archive size={18} />,
    child: [
      {
        id: shortid.generate(),
        path: '/inventory',
        component: lazy(() => import('../../views/Inventory')),
        exact: true,
      },
      {
        id: shortid.generate(),
        path: '/inventory/:projectId/:id',
        component: lazy(() => import('../../views/OrderDetail')),
        exact: true,
      },
    ],
  },
  {
    id: shortid.generate(),
    name: 'Vận chuyển',
    path: '/shipping',
    accessName: 'shipping',
    icon: <Truck size={18} />,
    child: [
      {
        id: shortid.generate(),
        path: '/shipping',
        component: lazy(() => import('../../views/Shipping')),
        exact: true,
      },
      {
        id: shortid.generate(),
        path: '/shipping/:projectId/:id',
        component: lazy(() => import('../../views/OrderDetail')),
        exact: true,
      },
    ],
  },
  {
    id: shortid.generate(),
    name: 'QL Kho',
    isSubMenu: true,
    accessName: 'warehouse',
    icon: <Database size={18} />,
    menuLayout: 'two-column',
    menuColumns: [
      { key: 'core', title: 'Nghiệp vụ' },
      { key: 'support', title: 'Bổ trợ' },
    ],
    child: [
      {
        id: shortid.generate(),
        name: 'Quản lý tổng quan',
        path: '/stock-management',
        icon: <Database size={18} />,
        component: lazy(() => import('../../views/StockManagement')),
        exact: true,
        group: 'core',
        accessName: 'warehouse_stock_dashboard_view',
      },
      {
        id: shortid.generate(),
        name: 'Phiếu kho',
        path: '/stock-management/documents',
        icon: <FileText size={18} />,
        component: lazy(() => import('../../views/StockManagementDocuments')),
        exact: true,
        group: 'core',
        accessName: 'warehouse_stock_draft_view',
      },

      {
        id: shortid.generate(),
        name: 'Hàng trong kho',
        path: '/stock-management/balances',
        icon: <Shield size={18} />,
        component: lazy(() => import('../../views/StockManagementBalances')),
        exact: true,
        group: 'core',
        accessName: 'warehouse_stock_balance_view',
      },
      {
        id: shortid.generate(),
        name: 'Chuyển kho',
        path: '/stock-management/transfers',
        icon: <Repeat size={18} />,
        component: lazy(() => import('../../views/StockManagementTransfers')),
        exact: true,
        group: 'core',
        accessName: 'warehouse_stock_transfer_view',
      },
      {
        id: shortid.generate(),
        name: 'Kiểm kho',
        path: '/stock-management/inventory-count',
        icon: <Clipboard size={18} />,
        component: lazy(() => import('../../views/StockManagementInventoryCount')),
        exact: true,
        group: 'core',
        accessName: 'warehouse_stock_inventory_count_view',
      },
      {
        id: shortid.generate(),
        name: 'Hàng lỗi',
        path: '/stock-management/damages',
        icon: <AlertOctagon size={18} />,
        component: lazy(() => import('../../views/StockManagementDamages')),
        exact: true,
        group: 'core',
        accessName: 'warehouse_stock_damage_view',
      },
      {
        id: shortid.generate(),
        name: 'Đóng gói',
        path: '/packing',
        icon: <Package size={18} />,
        component: lazy(() => import('../../views/Packing')),
        exact: true,
        group: 'core',
        accessName: 'packing',
      },
      {
        id: shortid.generate(),
        path: '/stock-management/documents/create',
        component: lazy(() => import('../../views/StockManagementDocumentForm')),
        exact: true,
        hidden: true,
        accessName: 'warehouse_stock_document_create',
      },
      {
        id: shortid.generate(),
        path: '/stock-management/documents/:id',
        component: lazy(() => import('../../views/StockManagementDetail')),
        exact: true,
        hidden: true,
        accessName: 'warehouse_stock_document_view',
      },
      {
        id: shortid.generate(),
        path: '/stock-management/documents/:id/edit',
        component: lazy(() => import('../../views/StockManagementDocumentForm')),
        exact: true,
        hidden: true,
        accessName: 'warehouse_stock_document_edit',
      },
      {
        id: shortid.generate(),
        name: 'Cài đặt vị trí kho',
        path: '/settings',
        query: 'tab=physical-warehouse',
        icon: <Settings size={18} />,
        component: lazy(() => import('../../views/Settings')),
        exact: true,
        group: 'support',
        accessName: 'setup',
      },
      {
        id: shortid.generate(),
        name: 'Lịch sử XNK',
        path: '/stock-management/ledger',
        icon: <Activity size={18} />,
        component: lazy(() => import('../../views/StockManagementLedger')),
        exact: true,
        group: 'support',
        accessName: 'warehouse_stock_ledger_view',
      },
      {
        id: shortid.generate(),
        name: 'Biên bản bàn giao',
        path: '/reports/shippingReceipts',
        icon: <Clipboard size={18} />,
        component: lazy(() => import('../../views/ShippingReceipt')),
        exact: true,
        group: 'support',
        accessName: 'reports_shipping_receipts',
      },
      {
        id: shortid.generate(),
        name: 'Duyệt xuất nhập kho',
        path: '/stock-management/pending-approvals',
        icon: <Clock size={18} />,
        component: lazy(() => import('../../views/StockManagementPendingApprovals')),
        exact: true,
        group: 'support',
        hidden: true,
        accessName: 'warehouse_stock_pending_approval_view',
      },
    ],
  },
  {
    id: shortid.generate(),
    name: 'Báo cáo',
    accessName: 'reports',
    exact: true,
    isSubMenu: true,
    icon: <PieChart size={18} />,
    child: [
      // {
      //   id: shortid.generate(),
      //   name: 'Vận đơn',
      //   path: '/reports/shipments',
      //   component: lazy(() => import('../../views/Shipment')),
      //   exact: true,
      //   image: '/images/menu/chart.svg',
      //   accessName: 'reports_shipments',
      // },
      {
        id: shortid.generate(),
        name: 'Biên bản bàn giao',
        path: '/reports/shippingReceipts',
        component: lazy(() => import('../../views/ShippingReceipt')),
        exact: true,
        icon: <FileText size={18} />,
        accessName: 'reports_shipping_receipts',
      },
      {
        id: shortid.generate(),
        path: '/reports/shippingReceipts/addNew',
        component: lazy(() => import('../../views/ShippingReceiptDetail')),
        exact: true,
        hidden: true,
      },
      {
        id: shortid.generate(),
        path: '/reports/shippingReceipts/:id',
        component: lazy(() => import('../../views/ShippingReceiptDetail')),
        exact: true,
        hidden: true,
      },
      {
        id: shortid.generate(),
        name: 'Doanh thu',
        path: '/reports/revenue',
        accessName: 'reports_sale_stats',
        component: lazy(() => import('../../views/Revenue')),
        exact: true,
        icon: <BarChart2 size={18} />,
      },
      {
        id: shortid.generate(),
        name: 'Đối soát',
        path: '/reports/reconciliation',
        accessName: 'reports_reconciliation',
        component: lazy(() => import('../../views/Reconciliation')),
        exact: true,
        icon: <CheckCircle size={18} />,
      },
    ],
  },
  {
    id: shortid.generate(),
    name: 'Cài đặt',
    path: '/settings',
    accessName: 'setup',
    exact: true,
    hidden: true,
    child: [
      {
        id: shortid.generate(),
        path: '/settings',
        component: lazy(() => import('../../views/Settings')),
        exact: true,
      },
      {
        id: shortid.generate(),
        path: '/settings/warehouseLocation/addNew',
        component: lazy(() =>
          import('../../views/Settings/components/WarehouseLocation/WarehouseDetail'),
        ),
        exact: true,
      },
      {
        id: shortid.generate(),
        path: '/settings/warehouseLocation/:id',
        component: lazy(() =>
          import('../../views/Settings/components/WarehouseLocation/WarehouseDetail'),
        ),
        exact: true,
      },
      {
        id: shortid.generate(),
        path: '/settings/warehouses/addNew',
        component: lazy(() => import('../../views/Settings/components/Warehouse/WarehouseDetail')),
        exact: true,
      },
      {
        id: shortid.generate(),
        path: '/settings/warehouses/:id',
        component: lazy(() => import('../../views/Settings/components/Warehouse/WarehouseDetail')),
        exact: true,
      },
    ],
  },
  // {
  //   id: shortid.generate(),
  //   name: 'Demo',
  //   path: '/demo',
  //   hidden: true,
  //   component: lazy(() => import('../../views/Demo')),
  //   exact: true,
  // },
  {
    id: shortid.generate(),
    name: 'Search',
    path: '/search',
    hidden: true,
    component: lazy(() => import('../../views/Search')),
    exact: true,
  },
];
